import React, { useState, useEffect, useRef } from 'react'
import styles from './assign.module.scss'
import type { KeyValueOption } from '../../../features/product-selector'

interface ProductInputsProps {
    classes?: Record<string, string>;
    label?: React.ReactNode;
    id: string;
    required?: boolean;
    listData?: KeyValueOption[];
    getValue: (key: string | number, value?: string) => void;
    error?: string;
    defaultValue?: string | number;
}

export const ProductInputs: React.FC<ProductInputsProps> = ({ classes, label, id, required, listData, getValue, error, defaultValue }) => {
    const [showDropDown, setShowDropDown] = useState(false)
    const [defaultValueadd, setDefaultValueadd] = useState<string | undefined>('')
    const [listDataOptions, setListDataOptions] = useState<KeyValueOption[] | undefined>(listData)
    const showDropDownList = () => {
        setShowDropDown(true)
    }
    useEffect(() => {
        const defaultSelect = listData?.find((x) => x.key === defaultValue);
        const inputEl = document.getElementById(id) as HTMLInputElement | null;
        if (defaultSelect?.value !== undefined) {
            if (inputEl) inputEl.value = defaultSelect?.value
        } else {
            if (inputEl) inputEl.value = ''
        }
        setDefaultValueadd(defaultSelect?.value)
    }, [listData, defaultValue])

    useEffect(() => {
        setListDataOptions(listData)
    }, [listData])

    const dropRef = useRef<HTMLElement | null>(null);
    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    });

    const handleClickOutside = (e: MouseEvent) => {
        if (dropRef !== null && dropRef.current && !dropRef.current.contains(e.target as Node)) {
            setShowDropDown(false);
        }
    };

    const addValue = (key: string | number, value: string, inputId: string) => {
        const inputEl = document.getElementById(inputId) as HTMLInputElement | null;
        if (inputEl) inputEl.value = value
        setDefaultValueadd(value);
        setShowDropDown(false);
        getValue(key, value)
        setListDataOptions(listData)
    }

    const searchList = (e: React.KeyboardEvent<HTMLInputElement>) => {
        const target = e.target as HTMLInputElement;
        let data: KeyValueOption[] = [];
        listData?.map((item) => {//NOSONAR
            const tlc = item.value.toLowerCase()
            const searchVal = target.value.toLowerCase()
            if (tlc.indexOf(searchVal) > -1) {
                return data = [...data, item]
            }
        })//NOSONAR
        setListDataOptions(data)
        setDefaultValueadd('')
        if (target.value === '') {
            // Clearing the search box intentionally reports an empty selection
            // back to the parent so it can clear its own dependent state.
            getValue('', '')
        }
    }

    return (
        <div className={`${classes?.column}`}>
            <label className={`${classes?.labelClassName}`}>
                {label}: {required ? <span>*</span> : ''}
            </label>
            <div className={`${classes?.inputColumn}`}>
                <input type="text" className={`${classes?.inputClassName}`} onClick={() => showDropDownList()} ref={dropRef as React.RefObject<HTMLInputElement>} placeholder="Select" defaultValue={defaultValueadd} onKeyUp={(e) => searchList(e)} id={id} autoComplete={'off'} />
                <div className={`dropdown-menu ${styles.product_selector_items} ${showDropDown ? 'show' : 'hide'}`} ref={dropRef as React.RefObject<HTMLDivElement>}>
                    <ul>
                        {
                            listDataOptions && listDataOptions?.length > 0 ? listDataOptions?.map((item, index) => {
                                return <li key={index} onClick={() => addValue(item.key, item.value, id)}>{item.value}</li>
                            }) : <li>No data</li>
                        }
                    </ul>
                </div>
                {error ? <span className={`${styles.error_message} mb-2 err-msg-product`}>{error}</span> : ''}
            </div>
        </div>
    )
}
